import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Link } from 'react-router-dom';
import rehypeRaw from 'rehype-raw';
import './index.scss';

type MarkdownProps = {
  content: string;
};

const Markdown: React.FC<MarkdownProps> = ({ content }) => (
  <div className="markdown-container">
    <ReactMarkdown
      rehypePlugins={[rehypeRaw]}
      components={{
        a: ({ href, children }) => {
          const isInternal = href && href.startsWith('/');

          if (isInternal) {
            return <Link to={href}>{children}</Link>;
          }

          return (
            <a href={href} target="_blank" rel="noopener noreferrer">
              {children}
            </a>
          );
        },
      }}
    >
      {content}
    </ReactMarkdown>
  </div>
);

export default Markdown;
